import { useFileOperations } from '@dev-streetbeat/chat/react';

import { FinecoDownloadIcon } from 'shared/assets/svg/FinecoDownloadIcon';

import type { File } from '@dev-streetbeat/chat/types';

import styles from './DownloadableArtifact.module.scss';

type Props = {
  file: File;
};

export const DownloadableArtifact: React.FC<Props> = ({ file }) => {
  const { downloadFile } = useFileOperations();

  const download = async () => {
    const fileName = file.name;
    const fileId = file.id;
    const response = await downloadFile(fileId);

    const link = document.createElement('a');
    link.href = URL.createObjectURL(response);
    link.download = fileName;
    link.click();
  };

  return (
    <>
      <div className={styles.downloadableContainer}>
        <div className={styles.downloadableContent} onClick={download}>
          <div className={styles.downloadIcon}>
            <FinecoDownloadIcon />
          </div>
        </div>
      </div>
      <div id={file.id.toString()} className="image-attachment-scroll-margin"></div>
    </>
  );
};
